<template>
  <div class="person-center-container">
    <div class="base-info-container">
      <div class="img-box avatar-box">
        <img v-lazy="avatar||userInfo.avatar" alt="" />
        <input
          title=""
          class="file"
          type="file"
          ref="file"
          @change="selectImg"
          accept="image/png,image/gif,image/jpeg"
        />
      </div>
      <div class="people-info-l">
        <div class="name">{{ userInfo.nickname }}</div>
        <div class="wec">欢迎回来~</div>
        <div class="event-btn">
          <span @click="resetPwd">密码修改</span>
          <span @click="centerLoginOut">安全退出</span>
        </div>
      </div>
      <div class="people-info-r">
        <!-- <div class="address">
          <span class="pl">收货地址：</span>
          <span class="pr">  {{ address }}</span>
        </div> -->
        <div class="get-people">
          <span class="pl">收货人：</span>
          <span v-if="changeList[0]" class="pr">{{ get_people_name }}</span>
          <input v-else type="text" v-model="get_people_name" class="input" />
          <span class="change" @click="toChange(0)" v-if="changeList[0]"
            >修改</span
          >
          <span class="confim" v-else @click="toConfim(0)">确定</span>
        </div>
        <div class="tel">
          <span class="pl">手机号码：</span>
          <span v-if="changeList[1]" class="pr">{{ get_people_tel }}</span>
          <input v-else type="text" v-model="get_people_tel" class="input" />
          <span class="change" @click="toChange(1)" v-if="changeList[1]"
            >修改</span
          >
          <span class="confim" v-else @click="toConfim(1)">确定</span>
        </div>
      </div>
    </div>
    <!-- <div class="order-baseinfo">
      <div class="title">
        <span class="span1">订单中心</span>
        <router-link tag="span" to="/person/myorder" class="span2"
          >所有订单</router-link
        >
      </div>
      <div class="info-container">
        <div class="info-item">
          <div class="img-box">
            <img :src="require('@/assets/images/icon_paid.png')" alt="" />
          </div>
          <div class="info-item-con">
            <p class="p1">
              待支付订单:
              <i style="color: #ffaa01">{{ orderCount.createCount }}</i>
            </p>
            <router-link tag="p" to="/person/myorder" class="p2"
              >查看订单</router-link
            >
          </div>
        </div>
        <div class="info-item">
          <div class="img-box">
            <img :src="require('@/assets/images/icon_receivinggoods.png')" alt="" />
          </div>
          <div class="info-item-con">
            <p class="p1">
              待收货订单：<i style="color: rgb(101, 182, 255)">{{
                orderCount.shippingCount
              }}</i>
            </p>
            <router-link tag="p" to="/person/myorder" class="p2"
              >查看订单</router-link
            >
          </div>
        </div>
        <div class="info-item">
          <div class="img-box">
            <img :src="require('@/assets/images/icon_refundt.png')" alt="" />
          </div>
          <div class="info-item-con">
            <p class="p1">
              售后中订单：<i style="color: rgb(162, 119, 230)">{{
                orderCount.returnsCount
              }}</i>
            </p>
            <router-link tag="p" to="/person/service" class="p2"
              >查看订单</router-link
            >
          </div>
        </div>
      </div>
    </div> -->
    <popup ref="popup"></popup>
    <success v-if="IsSuccess"></success>
  </div>
</template>

<script>
import popup from "./person-pwd-popup.vue";
import success from "../success.vue";
import axios from "axios";
import { mapState, mapMutations } from "vuex";
export default {
  components: { popup, success },
  data() {
    return {
      changeList: [true, true],
      get_people_name: "",
      get_people_tel: "",
      address: "",
      id:'',
      IsSuccess: false,
      orderCount: [],
      avatar: "",
    };
  },
  computed: {
    ...mapState(["hasLogin", "userInfo"]),
  },

  created() {
  this.getUserAddress()
  this.getOrderCount()
  if(this.$route.query.isShow){
    this.$nextTick(()=>{
        this.$refs.popup.show = true;
    })
   
  }
   
  },
  methods: {
    ...mapMutations(["LOGIN","LOGINOUT"]),
    toChange(index) {
      //console.log(index);
      this.$set(this.changeList, index, !this.changeList[index]);
      //console.log(this.changeList);
    },
    toConfim(index) {
      this.$set(this.changeList, index, !this.changeList[index]);
      //更新联系人手机号码名字
      this.$api
        .POST_USERPEOPLE({
          id: this.id,
          mobile: this.get_people_tel,
          name: this.get_people_name,
        })
        .then((res) => {
          //console.log(res);
          
        });
    },
    resetPwd() {
      this.$refs.popup.show = true;
    },
    success(data) {
      this.IsSuccess = data;
    },
    centerLoginOut() {
      this.$router.push("/home");
      this.LOGINOUT();
    },
    //上传图片
    selectImg() {
      let file = this.$refs.file.files[0];
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据

      this.$api.POST_UPLOADFILE(param).then((res) => {
        if(res.status){
        this.avatar = res.data;
        localStorage.setItem
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        userInfo.avatar = res.data;
        localStorage.setItem('userInfo',JSON.stringify(userInfo));
        this.$store.commit("CHANGEAVATAR",this.avatar)
 
        this.$api.POST_USERAVATAR({ avatar: this.avatar }).then((res) => {
          //console.log(res);
        });
        }
        
      });
      this.success(true)
    },
    getUserAddress(){
     //获取用户收货地址信息
       this.$api.GET_USERADDRESS().then((res) => {
         if(res.status){
         this.address = res.data.address;
         this.get_people_name = res.data.name;
         this.get_people_tel = res.data.mobile;
         this.id = res.data.id;
         //console.log(res.data);
         }
       });
    },
    getOrderCount(){
       //获取订单数
    this.$api.GET_ORDERCOUNT().then((res) => {
      if(res.status){
           this.orderCount = res.data;
          // console.log(this.orderCount);
      }
    });

    }
  },
};
</script>

<style lang="scss" scoped>
.person-center-container {
  .base-info-container {
    background: #ffffff;
    margin-bottom: 20px;
    padding-left: 60px;
    height: 234px;
    display: flex;
    align-items: center;
    .img-box {
      margin-right: 24px;
      img {
        width: 110px;
        height: 110px;
        border-radius: 50%;
      }
    }
    .people-info-l {
      border-right: 1px solid #f0f0f0;
      padding-right: 40px;
      margin-right: 40px;
      .name {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 16px;
      }
      .wec {
        font-size: 14px;
        color: #999999;
        margin-bottom: 16px;
      }
      .event-btn {
        span {
          display: inline-block;
          cursor: pointer;
          font-size: 14px;
          color: #808080;
          width: 80px;
          text-align: center;
          height: 28;
          line-height: 28px;
          margin-right: 12px;
          border: 1px solid #d9d9d9;
          border-radius: 3px;
        }
      }
    }
    .people-info-r {
      .change {
        cursor: pointer;
        color: #fa4b4b;
      }
      .confim {
        color: #ffffff;
        height: 26px;
        background: #fa4b4b;
        text-align: center;
        line-height: 26px;
        display: inline-block;
        width: 44px;
        border-radius: 3px;
        cursor: pointer;
        margin-left: 6px;
      }
      .input {
        font-size: 14px;
        border: 1px solid #d9d9d9;
        border-radius: 3px;
        padding: 4px 12px;
      }
      .pl {
        white-space: nowrap;
        font-size: 14px;
        color: #808080;
        text-align-last: justify;
        width: 70px;
        display: inline-block;
          line-height: 20px;

      }
      .pr {
        color: #505050;
        line-height: 20px;
      }
      .get-people {
       margin-bottom: 20px;
      }
      .address {
        width: 400px;
        display: flex;
       // line-height: 22px;
      }
    }
  }
  .order-baseinfo {
    background: #ffffff;
    height: 310px;
    padding: 40px 60px;
    .title {
      margin-bottom: 84px;
      .span1 {
        font-size: 18px;
        color: #333333;
        font-weight: 600;
      }
      .span2 {
        color: #505050;
        font-size: 14px;
        float: right;
        position: relative;
        cursor: pointer;
        &::after {
          @include wl-base;
          left: 64px;
          width: 6px;
          height: 10px;
          background: url("../../../../assets/images/icon_more2.png") no-repeat;
        }
      }
    }
    .info-container {
      display: flex;
      
      justify-content: space-between;
      .info-item {
        display: flex;
        .img-box {
          margin-right: 24px;
          img {
            width: 68px;
            height: 68px;
            border-radius: 50%;
          }
        }
        .info-item-con {
          @include flex-d-c;
          .p1 {
            font-size: 16px;
            color: #505050;
            margin-bottom: 12px;
            i {
              font-size: 16px;
              color: #ffaa01;
              font-weight: 600;
            }
          }
          .p2 {
            color: #808080;
            cursor: pointer;
            position: relative;
            &::after {
              @include wl-base;
              left: 64px;
              width: 6px;
              height: 10px;
              background: url("../../../../assets/images/icon_more.png")
                no-repeat;
            }
          }
        }
      }
    }
  }
}
.avatar-box {
  position: relative;

  &:hover::after {
      opacity: 0.45;
  }
  &::after {
    position: absolute;
    display: block;
    content: "更换头像";
    width: 100%;
    height: 100%;
     border-radius: 50%;
    background-color: black;  
      opacity: 0; 
    left: 0;
    bottom: 0;
    color: #ffffff;
    text-align: center;
    line-height: 110px;
    font-size: 16px;
  }
  .file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 10;
    cursor: pointer;

  }
}
</style>


// WEBPACK FOOTER //
// src/pages/person/components/person-center/index.vue